import { getAuthHeader } from "../tokenStorage";
import { axiosInstance, noCacheHeaders } from './axiosInstance';
import { fileServiceApiRoot } from '../constants/fileConstants';

const API_REQUEST_TIMEOUT_SECONDS = Number(window._env_.API_REQUEST_TIMEOUT_SECONDS || '45');
const FILE_SERVICE_TIMEOUT_MS = API_REQUEST_TIMEOUT_SECONDS * 1000;

export const createTextJamCommit = async (payload) => {

  const body = JSON.stringify({
    projectName: payload.name ?? "New Project",
    projectType: payload.project_type,
    repositoryId: payload.repositoryId,
    commitId: payload.commitId,
    extension: payload.extension,
    hasContentChanges: payload.hasContentChanges === true,
    programId: payload.programId,
    activitySetId: payload.activitySetId,
  });

  return axiosInstance.post(
    `/blapi/ide/repositories/commits/textjam-commit`,
    body,
    {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "application/json",
      },
    }
  ).then((res) => {
    return res;
  });
};

export const uploadTextJamFiles = async (payload) => {
  
  const {uploadUrl, ticketId, commitBlob} = payload;

  const formData = new FormData();
  formData.append("zip", commitBlob, "project.zip");

  return axiosInstance.post(
    `${uploadUrl}?ticketId=${encodeURIComponent(ticketId)}`,
    formData,
    {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
      timeout: FILE_SERVICE_TIMEOUT_MS,
    }
  ).then((res) => {
    return res;
  });
};

export const addCommit = async (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value != null) {
      formData.append(key, value);
    }
  });

  return axiosInstance.post(
    `/blapi/ide/commit`,
    formData,
    {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    }
  ).then((res) => {
    return res;
  });
};

export const getProjectByCommit = async (repositoryId, commitId) => {
  return axiosInstance.get(`/blapi/ide/repositories/${repositoryId}/commits/${commitId}`, {
    responseType: 'blob',
    headers: getAuthHeader(),
    timeout: FILE_SERVICE_TIMEOUT_MS,
  });
};

export const getMyRepository = async (payload) => {
  const { programId, activitySetId, repositoryId } = payload;
  const encodedActivitySetId = encodeURIComponent(activitySetId);

  return axiosInstance.get(
    !repositoryId ?
    `/blapi/ide/getMyRepository/${programId}/${encodedActivitySetId}` :
      `/blapi/ide/getMyRepositoryById/${repositoryId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getProjectByRepository = async (payload) => {
  const { programId, repositoryId, publicHash } = payload;

  return axiosInstance.get(
    !publicHash ? `/blapi/ide/getProjectByRepository/${!!programId ? `${programId}/` : ''}${repositoryId}` :
      `/blapi/ide/getPublicProjectByRepository/${repositoryId}/${publicHash}`
    ,
    {
      responseType: 'blob',
      headers: getAuthHeader(),
      timeout: FILE_SERVICE_TIMEOUT_MS,
    }
  );
};

export const getRepository = async (payload) => {
  const { programId, repositoryId, hash, publicHash } = payload;
  const encodedHash = encodeURIComponent(hash);

  return axiosInstance.get(
    !publicHash ? `/blapi/ide/getRepository/${!!programId ? `${programId}/` : ''}${repositoryId}/${encodedHash}` :
      `/blapi/ide/getPublicRepository/${repositoryId}/${encodedHash}/${publicHash}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getIsCommitSaved = async (repositoryId, commitId) => {
  return axiosInstance.get(
    `/blapi/ide/getIsCommitSaved/${repositoryId}/${commitId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
}

export const getTextJamTemplate = async (payload) => {
  const { templateId } = payload;

  return axiosInstance.get(`${fileServiceApiRoot}/textjam-template/${templateId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      },
      responseType: "arraybuffer"
    }
  );
};